import { LocalStorageError } from "./beam-errors";
import { logger } from "./logger";

/**
 * Creates an object that has the same API as normal localStorage, but adds a beam_ prefix and apiKey postfix to keys
 * Also adds helper methods for JSON (de-)serialization
 */
export const createScopedLocalStorage = (config: { apiKey: string }) => {
  // TODO: this is where we can check the schema version and do cleanup/migrations of old data
  // TODO: consider using a single Beam key in localstorage and storing JSON string
  return {
    get prefix() {
      return `beam_`;
    },
    get postfix() {
      return `_key_${config.apiKey}`;
    },
    getItem(key: string): string | null {
      return localStorage.getItem(this.prefix + key + this.postfix);
    },
    setItem(key: string, value: unknown) {
      return localStorage.setItem(this.prefix + key + this.postfix, `${value}`);
    },
    removeItem(key: string) {
      return localStorage.removeItem(this.prefix + key + this.postfix);
    },
    /** Safely parses value as JSON and return JS object */
    getItemJson<T = Record<string, unknown>>(key: string) {
      try {
        const json = this.getItem(key);
        if (json) {
          return JSON.parse(json) as T;
        }
      } catch (err) {
        logger.error(new LocalStorageError(`Could not parse JSON: ${key}`));
      }
      return null;
    },
    /** Safely stringifies value as JSON */
    setItemJson(key: string, value: object) {
      return this.setItem(key, JSON.stringify(value));
    },
  };
};
